// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XObqE0uXwjowKGNB {
  width: 180px;
  height: 120px;
  border-radius: 2px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px dashed #2c99ff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.Fb7jOMxA4o0pKxMh {
  color: #666666;
  font-size: 14px;
  line-height: 19px;
  margin-top: 8px;
}
.zTcuksEM_Z4J2VtN {
  width: 32px;
  height: 32px;
}
.n8KdpNwho9chYL1p {
  font-size: 14px;
  color: #999999;
  line-height: 18px;
  margin-top: 5px;
}
.customs3_upload .ant-upload-list-item-progress {
  display: none;
}
.customs3_upload .ant-upload {
  width: 180px !important;
  height: 120px !important;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/S3Upload/index.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;AACA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACF;AACA;EACE,WAAA;EACA,YAAA;AACF;AACA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AACF;AAEA;EAGM,aAAA;AAFN;AADA;EAMM,uBAAA;EACA,wBAAA;AAFN","sourcesContent":[".uploadCt {\n  width: 180px;\n  height: 120px;\n  border-radius: 2px;\n  background: #ffffff;\n  box-sizing: border-box;\n  border: 1px dashed #2c99ff;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.uploadText {\n  color: #666666;\n  font-size: 14px;\n  line-height: 19px;\n  margin-top: 8px;\n}\n.UploadIcon {\n  width: 32px;\n  height: 32px;\n}\n.uploadTips {\n  font-size: 14px;\n  color: #999999;\n  line-height: 18px;\n  margin-top: 5px;\n}\n\n:global {\n  .customs3_upload {\n    .ant-upload-list-item-progress {\n      display: none;\n    }\n    .ant-upload {\n      width: 180px !important;\n      height: 120px !important;\n    }\n    // .ant-upload-list-item-container {\n    //   width: 180px !important;\n    //   height: 120px !important;\n    //   position: relative;\n    //   border: 1px solid rgba(44, 153, 255, 0.5);\n    //   box-sizing: border-box;\n    // }\n  }\n  // .custom-item-renderer {\n  //   width: 100%;\n  //   height: 100%;\n  //   border-radius: 2px;\n  //   img {\n  //     width: 100%;\n  //     height: 100%;\n  //     object-fit: cover;\n  //     box-sizing: border-box;\n  //     position: static;\n  //   }\n  // }\n  // .mask-r {\n  //   position: absolute;\n  //   width: 48px;\n  //   height: 24px;\n  //   background: rgba(0, 0, 0, 0.6);\n  //   right: 0;\n  //   bottom: 0;\n  //   text-align: center;\n  //   line-height: 24px;\n  // }\n  // .mask-icon {\n  //   color: #fff;\n  // }\n  // .preview {\n  //   margin-right: 4px;\n  //   display: inline-block;\n  //   vertical-align: middle;\n  // }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadCt": `XObqE0uXwjowKGNB`,
	"uploadText": `Fb7jOMxA4o0pKxMh`,
	"UploadIcon": `zTcuksEM_Z4J2VtN`,
	"uploadTips": `n8KdpNwho9chYL1p`
};
export default ___CSS_LOADER_EXPORT___;
